import React from 'react';

const routes = [
        // { path: '/withdrawal', name: 'withdrawal', component: Withdrawal },
        // { path: '/history', name: 'History', component: History },
        // { path: '/benefits', name: 'Benefits', component: Benefits },
        // { path: '/coach', name: 'Coach', component: Coach },
        // { path: '/support', name: 'Support', component: Support },
];

export default routes;
